import { JobSiteModel } from "src/app/fs-lte/models/customer/job-site-detail-model";
import { CustomerModel } from "@fs/models/customer.model";
import { CodeTypeModel } from "@fs/models/code-type.model";
import { PromisedTimeModel } from "@fs/models/promised-time.model";
import { UserModel } from "src/app/fs-lte/models/customer/billing-detail.model";
import { WorkOrderModel } from "@fs/models/work-order/work-order.model";
import { Attachment } from "@fs/models/price-book/material-item.model";

export class WorkOrderReviewModel{
    
    ID: string
    JobSite: JobSiteModel
    Customer: CustomerModel
    Department: Department
    Status: CodeTypeModel
    SubStatus: CodeTypeModel
    PromisedTime: PromisedTimeModel
    OwnerUser: UserModel
    Priority:WorkTicketPriority
    WorkTicketNo:string
    DispatchComment:string
    RequestedBy:string
    PromisedDate: string
    CustomerPO:string
    Issue:string
    SendAppointmentConfirmation:boolean
    AssignedTechnicians:WorkTicketTechnician[]
    WorkTicketPriceBookItems:WorkTicketItem[]
    WorkTicketItems:WorkTicketItem[]
    WorkTicketPayment:WorkTicketPayment
    WorkTicketDiscountItems:any=[];
    WorkTicketDiscountItem:WorkTicketDiscountItem
    IsActive:boolean
    ServiceType:ServiceType
    ModifyDate: string
    Attachments:Attachment[]
    Duration:string
    UserAppointments: UserAppointment[];
    public constructor(){
        this.ID="",
        this.AssignedTechnicians = [],
        this.WorkTicketPriceBookItems = [],
        this.WorkTicketItems = [],
        this.ModifyDate = "",
        this.UserAppointments= [];
    } 
}
export class UserAppointment
{
    ID: string;
    UserID: string;
    AppointmentTypeID: string;
    AppointmentDate:string;
    StartTime: string;
    EndTime: string;
    Note: string;
    WorkTicketID: string;
    StatusID:string;
    SubStatusID:string;
    ModifyDate: string;
    IsSchedule : boolean;
    IsDirty: boolean;
    public constructor()
    {
        this.ID = '';
        this.UserID = '';
        this.AppointmentTypeID = '';
        this.AppointmentDate ='';
        this.StartTime = '';
        this.EndTime = '';
        this.Note = '';
        this.WorkTicketID = '';
        this.StatusID ='';
        this.SubStatusID ='';
        this.ModifyDate = '';
        this.IsSchedule = false;
        this.IsDirty = false;
    }

}
export class Department{
    ID:string;
    Name:string;
    Description:string
}

export class WorkTicketPriority{
    ID:string;
    Name:string;
    Description:string
}

export class WorkTicketTechnician{
    PromisedDate:string;
    User:UserModel;
    StartTime:string;
    EndTime:string;
    IsPrimary:boolean;
    IsDirty:boolean;
    ID:string;
}

export class WorkTicketItem{
    ID:string;
    Quantity:string;
    WorkTicket:WorkOrderModel;
    Note:string
    Status: CodeTypeModel
    WorkTicketPriceBookItem: WorkTicketPriceBookItem
}

export class WorkTicketPriceBookItem {
    LineCounter: string;
    Quantity: number;
    Price: string;
    Description: string;
    Note: string;
    Status: any;
    WorkStatus: any
    WorkTicketDiscountItems: any
    AccountingCode: any
    ID: string;
    IsDirty: boolean;
    TextField: string;
    ImagePath: string;
    WorkTicketPriceBookItem(){
        this.IsDirty = false;
    }
}

export class WorkTicketPayment{
    TotalApprovedPrice:string;
    NetTaxable:string;
    TaxGroup:any;
    TaxedAmount:string;
    TaxID:string
    TotalPaid: string
    AppliedCredit:string
    CustomerSignImgUrl:string;
    TechnicianSignImgUrl:string
    SignatureDateTime:Date
    InvoiceComment:string
    InvoiceDate: string;
    CustomerSignText:string
    WorkTicketPaidDetails:any=[]
    WorkTicketPayment:WorkTicketPaidDetails[]
}

export class WorkTicketPaidDetails{
    PaymentType:CodeTypeModel;
    DateTime:Date;
    PaymentDetails:string;
    Amount:string
    EndTotalPayment: string
    Issue:string  
}

export class ServiceType{
    ID:string;
}

export class WorkTicketDiscountItem{
    ID: string
    Discount: Discount
    Name: string 
    Rate?: number = 0;
    DiscountType: any
    IsDirty: boolean = false
    IsDeleted: boolean = false
    IsCustom: boolean = false
    WorkTicketPriceBookItemIDs: any = []
}

export class Discount{
    ID: string
    Name: string
    DiscountType: any
    Amount: number
    IsAmountEditable: boolean
    IsNameEditable: boolean
}

export class PaymentModel{
    WorkOrder: any
    PaymentType: CodeTypeModel
    Amount: number
    Comment: String 
    CardType: string;
    PayerName: String
    CheckNumber: String
    Account: any
    Expiery: String 
    CVV: String 
    PostalCode: String
    ConfirmationCode: String
}